import { render, staticRenderFns } from "./CourseStructureList.vue?vue&type=template&id=12ede8b5"
import script from "./CourseStructureList.vue?vue&type=script&lang=js"
export * from "./CourseStructureList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports